exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formControl {\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 20px;\n  line-height: 150%;\n  text-align: justify; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/utils/rodo.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB,EAAE","file":"rodo.scss","sourcesContent":[".formControl {\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 20px;\n  line-height: 150%;\n  text-align: justify; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/utils/rodo.scss
// module id = 813
// module chunks = 0